import { subWeeks } from 'date-fns';
import { atom } from 'jotai';

import type {
  THygieneTaskCode,
  TProviderRole,
  TTreatmentType,
} from '../../../react-query/insights/types';

export const startDateAtom = atom<Date>(subWeeks(new Date(), 8));
export const endDateAtom = atom<Date>(new Date());

/** How the previous (comparison) period is determined. */
export type ComparisonPeriodMode = 'trailing' | 'yoy' | 'custom';

export const comparisonPeriodModeAtom = atom<ComparisonPeriodMode>('trailing');

/** Custom prior period start; used only when comparisonPeriodModeAtom is 'custom'. */
export const customPriorStartDateAtom = atom<Date | null>(null);
/** Custom prior period end; used only when comparisonPeriodModeAtom is 'custom'. */
export const customPriorEndDateAtom = atom<Date | null>(null);

export const selectedPracticesAtom = atom<string[]>([]);
export const selectedPracticeGroupsAtom = atom<string[]>([]);

export const txTypeAtom = atom<TTreatmentType[]>([]);
export const taskTypeAtom = atom<THygieneTaskCode[]>([]);

export const selectedProviderRoleAtom = atom<TProviderRole[]>([]);

export const selectedPracticeCategoryAtom = atom<
  | { status: 'planned' | 'scheduled' | 'completed'; category: number }
  | undefined
>(undefined);

export const selectedProviderCategoryAtom = atom<
  | { status: 'planned' | 'scheduled' | 'completed'; category: number }
  | undefined
>(undefined);

export const providerBenchmarkAtom = atom<{
  lowerBenchmark: number;
  upperBenchmark: number;
}>({
  lowerBenchmark: 0,
  upperBenchmark: 0,
});

export const hygieneProviderBenchmarkAtom = atom<{
  lowerBenchmark: number;
  upperBenchmark: number;
}>({
  lowerBenchmark: 0,
  upperBenchmark: 0,
});

export const isCountsAtom = atom<boolean>(false);

export const DEFAULT_MATERIALITY_FILTER_DOLLARS = 0;
export const DEFAULT_MATERIALITY_FILTER_COUNTS = 0;

export const materialityFilterProductionDollarsAtom = atom<number>(
  DEFAULT_MATERIALITY_FILTER_DOLLARS,
);

export const materialityFilterProductionCountsAtom = atom<number>(
  DEFAULT_MATERIALITY_FILTER_COUNTS,
);

export const DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_DOLLARS = 0;
export const DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_COUNTS = 0;

export const materialityFilterOpportunityDollarsAtom = atom<number>(
  DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_DOLLARS,
);

export const materialityFilterOpportunityCountsAtom = atom<number>(
  DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_COUNTS,
);
